import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, Grid2 } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ModalTitleIconed } from 'asterX-UI/Modals/index'
import PropTypes from 'prop-types'

const DialogContainer = styled(Dialog)(({ theme, maxWidth }) => ({
  '& .MuiPaper-root': {
    maxWidth: maxWidth || 'sm'
  }
}))

const ActionModal = ({
  open,
  onClose,
  color = 'primary',
  onCancel,
  onConfirm,
  confirmVariant = 'contained',
  title = '',
  labelCancel = 'Отмена',
  labelConfirm = 'Подтвердить',
  iconComponent = null,
  disableConfirm = false,
  cancelBtnRed = null,
  borderColor = null,
  subtitle = '',
  rootStyles = {},
  maxWidth = 'sm',
  cancelBtnColor = 'primary',
  ...other
}) => {
  return (
    <DialogContainer open={open} maxWidth={maxWidth} fullWidth onClose={onClose} {...rootStyles} {...other}>
      <ModalTitleIconed onClose={onClose} iconComponent={iconComponent} subtitle={subtitle}>
        {title}
      </ModalTitleIconed>
      <DialogContent sx={{ padding: '20px' }}>{other.children}</DialogContent>
      {!!(onConfirm || onCancel) && (
        <DialogActions>
          <Grid2
            container
            spacing={2}
            sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '100%' }}
          >
            <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
              {cancelBtnRed ? (
                <Button variant={'contained'} color={'secondary'} fullWidth onClick={onCancel}>
                  {labelCancel}
                </Button>
              ) : (
                <Button variant={'outlined'} color={cancelBtnColor} fullWidth onClick={onCancel}>
                  {labelCancel}
                </Button>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
              <Button
                variant={confirmVariant}
                color={color}
                fullWidth
                disabled={disableConfirm}
                onClick={onConfirm}
                sx={{ borderColor: borderColor ? borderColor : 'inherit' }}
              >
                {labelConfirm}
              </Button>
            </Grid2>
          </Grid2>
        </DialogActions>
      )}
    </DialogContainer>
  )
}

ActionModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'black']),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disableConfirm: PropTypes.bool,
  subtitle: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  labelCancel: PropTypes.string,
  labelConfirm: PropTypes.string,
  iconComponent: PropTypes.node
}

export default ActionModal
